import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faLocationDot } from '@fortawesome/free-solid-svg-icons';

function Contact() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    const [formStatus, setFormStatus] = useState('');

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // For now, we'll just log the form data
        // In a real application, you'd send this to a backend service
        console.log('Form submitted:', formData);
        setFormStatus('Thank you for your message! I will get back to you soon.');
        setFormData({ name: '', email: '', subject: '', message: '' });

        // Clear success message after 5 seconds
        setTimeout(() => setFormStatus(''), 5000);
    };

    const contactInfo = [
        {
            icon: faEnvelope,
            label: 'Email',
            value: 'cetta.charles.contact@gmail.com',
            link: 'mailto:cetta.charles.contact@gmail.com'
        },
        {
            icon: faLinkedin,
            label: 'LinkedIn',
            value: 'Connect with me',
            link: 'https://www.linkedin.com/in/charles-cetta-44b620228/'
        },
        {
            icon: faGithub,
            label: 'GitHub',
            value: 'View my work',
            link: 'https://github.com/charles-cetta'
        },
        {
            icon: faLocationDot,
            label: 'Location',
            value: 'Open to opportunities nationwide',
            link: null
        }
    ];

    return (
        <main style={{ maxWidth: '1000px', margin: '0 auto', padding: '4rem 2rem' }}>
            <section style={{ textAlign: 'center', marginBottom: '3rem' }}>
                <h1 style={{ marginBottom: '1rem' }}>Get In Touch</h1>
                <p style={{ fontSize: '1.1rem', color: '#666', maxWidth: '600px', margin: '0 auto' }}>
                    I'm always interested in new opportunities, collaborations, or just chatting about
                    data science and finance. Feel free to reach out!
                </p>
            </section>

            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                gap: '3rem',
                marginTop: '3rem'
            }}>
                {/* Contact Information */}
                <div>
                    <h2 style={{ fontSize: '1.5rem', marginBottom: '1.5rem' }}>
                        Contact Information
                    </h2>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
                        {contactInfo.map((info, index) => (
                            <div
                                key={index}
                                style={{
                                    display: 'flex',
                                    alignItems: 'flex-start',
                                    gap: '1rem',
                                    padding: '1rem',
                                    backgroundColor: '#FEFDFB',
                                    borderRadius: '8px',
                                    border: '1px solid #E8DDD0'
                                }}
                            >
                                <FontAwesomeIcon
                                    icon={info.icon}
                                    style={{
                                        fontSize: '1.3rem',
                                        color: '#A0522D',
                                        marginTop: '0.2rem'
                                    }}
                                />
                                <div style={{ flex: 1 }}>
                                    <p style={{
                                        margin: '0 0 0.25rem 0',
                                        fontWeight: '600',
                                        color: '#333',
                                        fontSize: '0.95rem'
                                    }}>
                                        {info.label}
                                    </p>
                                    {info.link ? (
                                        <a
                                            href={info.link}
                                            target={info.link.startsWith('http') ? '_blank' : undefined}
                                            rel={info.link.startsWith('http') ? 'noopener noreferrer' : undefined}
                                            style={{
                                                color: '#A0522D',
                                                textDecoration: 'none',
                                                fontSize: '0.95rem'
                                            }}
                                        >
                                            {info.value}
                                        </a>
                                    ) : (
                                        <p style={{ margin: 0, color: '#666', fontSize: '0.95rem' }}>
                                            {info.value}
                                        </p>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Quick Note */}
                    <div style={{
                        marginTop: '2rem',
                        padding: '1.5rem',
                        backgroundColor: '#FFF5EB',
                        borderRadius: '8px',
                        border: '1px solid #E8DDD0'
                    }}>
                        <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1.1rem' }}>
                            Looking for opportunities in:
                        </h3>
                        <ul style={{
                            margin: '0.5rem 0 0 0',
                            paddingLeft: '1.5rem',
                            color: '#555',
                            lineHeight: '1.8'
                        }}>
                            <li>Quantitative Analysis</li>
                            <li>Data Science & ML Engineering</li>
                            <li>Financial Technology</li>
                            <li>Research & Development</li>
                        </ul>
                    </div>
                </div>

                {/* Contact Form */}
                <div>
                    <h2 style={{ fontSize: '1.5rem', marginBottom: '1.5rem' }}>
                        Send a Message
                    </h2>
                    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                        <div>
                            <label
                                htmlFor="name"
                                style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    fontWeight: '500',
                                    color: '#333',
                                    fontSize: '0.95rem'
                                }}
                            >
                                Name *
                            </label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                style={{
                                    width: '100%',
                                    padding: '0.75rem',
                                    border: '1px solid #ddd',
                                    borderRadius: '5px',
                                    fontSize: '1rem',
                                    fontFamily: 'inherit',
                                    boxSizing: 'border-box'
                                }}
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="email"
                                style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    fontWeight: '500',
                                    color: '#333',
                                    fontSize: '0.95rem'
                                }}
                            >
                                Email *
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                                style={{
                                    width: '100%',
                                    padding: '0.75rem',
                                    border: '1px solid #ddd',
                                    borderRadius: '5px',
                                    fontSize: '1rem',
                                    fontFamily: 'inherit',
                                    boxSizing: 'border-box'
                                }}
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="subject"
                                style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    fontWeight: '500',
                                    color: '#333',
                                    fontSize: '0.95rem'
                                }}
                            >
                                Subject *
                            </label>
                            <input
                                type="text"
                                id="subject"
                                name="subject"
                                value={formData.subject}
                                onChange={handleChange}
                                required
                                style={{
                                    width: '100%',
                                    padding: '0.75rem',
                                    border: '1px solid #ddd',
                                    borderRadius: '5px',
                                    fontSize: '1rem',
                                    fontFamily: 'inherit',
                                    boxSizing: 'border-box'
                                }}
                            />
                        </div>

                        <div>
                            <label
                                htmlFor="message"
                                style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    fontWeight: '500',
                                    color: '#333',
                                    fontSize: '0.95rem'
                                }}
                            >
                                Message *
                            </label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                required
                                rows="6"
                                style={{
                                    width: '100%',
                                    padding: '0.75rem',
                                    border: '1px solid #ddd',
                                    borderRadius: '5px',
                                    fontSize: '1rem',
                                    fontFamily: 'inherit',
                                    resize: 'vertical',
                                    boxSizing: 'border-box'
                                }}
                            />
                        </div>

                        <button
                            type="submit"
                            style={{
                                padding: '0.875rem 2rem',
                                backgroundColor: '#A0522D',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                fontSize: '1rem',
                                fontWeight: '500',
                                cursor: 'pointer',
                                transition: 'background-color 0.2s',
                                fontFamily: 'inherit'
                            }}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#8B4513'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#A0522D'}
                        >
                            Send Message
                        </button>

                        {formStatus && (
                            <div style={{
                                padding: '1rem',
                                backgroundColor: '#d4f4dd',
                                border: '1px solid #a3dbb1',
                                borderRadius: '5px',
                                color: '#1e7e34',
                                fontSize: '0.95rem'
                            }}>
                                {formStatus}
                            </div>
                        )}
                    </form>
                </div>
            </div>

            {/* Map Section */}
            <section style={{ marginTop: '4rem' }}>
                <h2 style={{ fontSize: '1.5rem', marginBottom: '1.5rem', textAlign: 'center' }}>
                    Location
                </h2>
                <div style={{
                    border: '2px solid #E8DDD0',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    boxShadow: '0 4px 12px rgba(184, 87, 78, 0.1)'
                }}>
                    <iframe
                        title="Location Map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387190.2798904705!2d-74.25986548248684!3d40.69767006338158!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNew%20York%2C%20NY!5e0!3m2!1sen!2sus!4v1234567890123"
                        width="100%"
                        height="400"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                    />
                </div>
                <p style={{
                    textAlign: 'center',
                    marginTop: '1rem',
                    color: '#666',
                    fontSize: '0.95rem'
                }}>
                    Based in the New York City metropolitan area
                </p>
            </section>
        </main>
    );
}

export default Contact;